const SET_SEARCH_PARAMS = 'SET_SEARCH_PARAMS';

const UPDATE_WORKPLACE_AUTOCOMPLETE_SUGGESTIONS = 'UPDATE_WORKPLACE_AUTOCOMPLETE_SUGGESTIONS';
const ADD_WORKPLACE_AUTOCOMPLETE_TOKEN = 'ADD_WORKPLACE_AUTOCOMPLETE_TOKEN';
const ADD_WORKPLACE_AUTOCOMPLETE_CUSTOM_TOKEN = 'ADD_WORKPLACE_AUTOCOMPLETE_CUSTOM_TOKEN';
const REMOVE_WORKPLACE_AUTOCOMPLETE_TOKEN = 'REMOVE_WORKPLACE_AUTOCOMPLETE_TOKEN';
const SHOW_WORKPLACE_AUTOCOMPLETE_LATEST = 'SHOW_WORKPLACE_AUTOCOMPLETE_LATEST';
const GENERATE_WORKPLACE_AUTOCOMPLETE_TOKENS = 'GENERATE_WORKPLACE_AUTOCOMPLETE_TOKENS';

const UPDATE_KEYWORD_AUTOCOMPLETE_SUGGESTIONS = 'UPDATE_KEYWORD_AUTOCOMPLETE_SUGGESTIONS';
const ADD_KEYWORD_AUTOCOMPLETE_TOKEN = 'ADD_KEYWORD_AUTOCOMPLETE_TOKEN';
const ADD_KEYWORD_AUTOCOMPLETE_CUSTOM_TOKEN = 'ADD_KEYWORD_AUTOCOMPLETE_CUSTOM_TOKEN';
const REMOVE_KEYWORD_AUTOCOMPLETE_TOKEN = 'REMOVE_KEYWORD_AUTOCOMPLETE_TOKEN';
const SHOW_KEYWORD_AUTOCOMPLETE_LATEST = 'SHOW_KEYWORD_AUTOCOMPLETE_LATEST';
const GENERATE_KEYWORD_AUTOCOMPLETE_TOKENS = 'GENERATE_KEYWORD_AUTOCOMPLETE_TOKENS';

const SET_AUTOCOMPLETE_LATEST_SEARCH = 'SET_AUTOCOMPLETE_LATEST_SEARCH';
const SHOW_AUTOCOMPLETE_WORKPLACE = 'SHOW_AUTOCOMPLETE_WORKPLACE';
const SHOW_AUTOCOMPLETE_KEYWORD = 'SHOW_AUTOCOMPLETE_KEYWORD';

const UPDATE_WORKPLACE_AUTOCOMPLETE_VALUE = 'UPDATE_WORKPLACE_AUTOCOMPLETE_VALUE';
const UPDATE_KEYWORD_AUTOCOMPLETE_VALUE = 'UPDATE_KEYWORD_AUTOCOMPLETE_VALUE';

const SET_RADIUS_OPEN = 'SET_RADIUS_OPEN';
const SET_RADIUS = 'SET_RADIUS';
const CHECK_RADIUS = 'CHECK_RADIUS';

export {
  SET_SEARCH_PARAMS,
  UPDATE_WORKPLACE_AUTOCOMPLETE_SUGGESTIONS,
  ADD_WORKPLACE_AUTOCOMPLETE_TOKEN,
  ADD_WORKPLACE_AUTOCOMPLETE_CUSTOM_TOKEN,
  REMOVE_WORKPLACE_AUTOCOMPLETE_TOKEN,
  SHOW_WORKPLACE_AUTOCOMPLETE_LATEST,
  GENERATE_WORKPLACE_AUTOCOMPLETE_TOKENS,
  UPDATE_KEYWORD_AUTOCOMPLETE_SUGGESTIONS,
  ADD_KEYWORD_AUTOCOMPLETE_TOKEN,
  ADD_KEYWORD_AUTOCOMPLETE_CUSTOM_TOKEN,
  REMOVE_KEYWORD_AUTOCOMPLETE_TOKEN,
  SHOW_KEYWORD_AUTOCOMPLETE_LATEST,
  GENERATE_KEYWORD_AUTOCOMPLETE_TOKENS,
  SET_AUTOCOMPLETE_LATEST_SEARCH,
  SHOW_AUTOCOMPLETE_WORKPLACE,
  SHOW_AUTOCOMPLETE_KEYWORD,
  UPDATE_WORKPLACE_AUTOCOMPLETE_VALUE,
  UPDATE_KEYWORD_AUTOCOMPLETE_VALUE,
  SET_RADIUS_OPEN,
  SET_RADIUS,
  CHECK_RADIUS
};
